import { Resource } from "./resource";

export interface DeleteActions {
  deleteItem(id: string | number): Promise<void>;
}

export function createDeleteResource(apiUrl: string): Resource<DeleteActions> {
  return (client) => ({
    async deleteItem(id) {
      const resp = await client.delete(`${apiUrl}${id}/`);
    },
  });
}
